<span class="user">
  @if (userService.isLoggedIn()) {
    <span><i class="material-icons">person</i>&nbsp; {{userService.user().name }}</span>
  }
  <!-- <span *ngIf="!userService.isLoggedIn()">Login</span> -->
</span>